import { ROUTER_NAME_HOME } from '@/features/home/home.router';
import { usePUserStore } from '@/store';
import { getUserInfo, isWpsEnv } from '@/utils/get-user-info';
import { initScript } from '@/utils/load-js-to-dom';
import { showWpsLoginAsync } from '@/utils/wps-fn';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

/**
 * 未登录状态显示相关数据
 * @param to
 */
function showPageUnloginState(to: RouteLocationNormalized) {
  const isWps = isWpsEnv();
  if (isWps) {
    // 显示登录弹窗
    showWpsLoginAsync();
  } else {
    if (window.location.href.indexOf(to.path) === -1) {
      location.reload();
    }
  }
}

/**
 * 检查登录状态
 */
function checkLoginState(to: RouteLocationNormalized) {
  const userStore = usePUserStore();
  const { isLogin } = userStore;
  if (!isLogin) {
    // 未登录状态，请求接口判断登录状态(未登录自动跳转首页)
    getUserInfo();
    // .then((isSuccess) => {
    //   if (!isSuccess) {
    //     showPageUnloginState(to);
    //   }
    // })
    // .catch(() => {
    //   showPageUnloginState(to);
    // });
  }
}

/**
 * 更新浏览器标题
 *
 * @param to
 * @returns
 */
const updateDocTitle = (to: RouteLocationNormalized) => {
  // if (ROUTER_NAME_HOME !== to.name) {
  //   // 中间页逻辑
  //   document.title = 'WPS轻应用';
  //   return;
  // }

  document.title = 'WPS轻应用';
};
export function routerBeforeEach(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  // 更新浏览器标题
  updateDocTitle(to);

  // 动态加载 commonjs-2t performance-js dw等
  initScript();

  // 判断用户登录状态
  checkLoginState(to);

  next();
}
